class SPLoadingSpinner extends HTMLElement {
	connectedCallback() {
		this.spinner = this.querySelector('.loading-spinner');
	}

	get loading() {
		return this.spinner.hasAttribute('data-active');
	}

	set loading(state) {
		if (state) {
			this.spinner.setAttribute('data-active', true);
			this.removeAttribute('hidden');
		} else {
			this.spinner.removeAttribute('data-active');
			this.setAttribute('hidden', true);
		}
	}
}

customElements.define('sp-loading-spinner', SPLoadingSpinner);